import {Typography, Box, Card, Grid, CardContent, Button} from '@mui/material';

import {Avatar} from '@jobseeker/lotus/components';
import {Image} from '@jobseeker/lotus/components/Image';

import {useDispatch, useSelector} from 'react-redux';
import {
  handleTracking,
  openUrl,
  TrackEventUBA,
} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {
  fetchJobDetails,
  fetchJobInsights,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobdetail';
import ScheduledInterview from '@jobseeker/feature-job/components/AppliedJobs/AppliedJobsDesktop/internalComponents/ScheduledInterview';
import {
  AppliedTileProps,
  RECRUITER_ACTION_TEXT,
} from '@jobseeker/feature-job/components/AppliedJobs/AppliedJobsDesktop/types';
import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';

import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import userService from '@jobseeker/common-core/services/user.service';
import {useEffect, useRef, useState} from 'react';
import {BottomsheetNoTtitle} from '@jobseeker/lotus/elements';
import {JobdetailQr} from '@jobseeker/lotus/assets/images/index';
import {IndianRupee, LockPrem, RupeeGrey} from '@jobseeker/lotus/assets/icons';
import LockedStatus from '@jobseeker/feature-job/components/AppliedJobs/AppliedJobsDesktop/internalComponents/LockedStatus';
import {formatSalary} from '@jobseeker/lotus/utils';

const AppliedMobTile = ({
  id,
  applicantId,
  applicationId,
  applicationDate,
  recruiterDetail,
  recruiterAction,
  jobDetail,
  followUp,
  views,
  app_count,
  unpublishInfo,
  confidential,
  app_status,
  recruiterActions,
  inviteStatus,
  lastActive,
  isPro,
  hasfollowup,
  interviewDate,
  interviewTime,
  calId,
  slotId,
  remSlots,
  isStatusChangeCohortUser,
  setshowProMembershipPrompt,
  setShowFollowUpProMembershipPrompt,
  setInsightsbox,
  setShowStatusProMembershipPrompt,
  minSal,
  maxSal,
  hideSal,
}: AppliedTileProps) => {
  const loc = jobDetail.location.map(obj => {
    return obj.name;
  });
  const salaryString = formatSalary(minSal, maxSal, hideSal);
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  // useValidateAuth(dispatch);
  function removeHtmlAndAppendRef(url: string) {
    // Remove ".html" at the end if present
    const cleanedUrl = url.endsWith('.html') ? url.slice(0, -5) : url;

    // Check if the URL already contains a query string
    if (cleanedUrl.includes('?')) {
      return `${cleanedUrl}&ref=apj`;
    }

    // If no query string is present, append `?ref=akf`
    return `${cleanedUrl}?ref=apj`;
  }

  const jobUrl = removeHtmlAndAppendRef(jobDetail.jobUrl);

  const formatPostedTime = (createdTime: string | number): string => {
    const currentTime = new Date();
    const jobTime = new Date(createdTime);
    const differenceInMilliseconds = currentTime.getTime() - jobTime.getTime();

    const differenceInDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );
    const differenceInWeeks = Math.floor(differenceInDays / 7);
    const differenceInMonths = Math.floor(differenceInDays / 30); // Approximate: 1 month = 30 days
    const differenceInYears = Math.floor(differenceInDays / 365); // Approximate: 1 year = 365 days

    if (differenceInYears >= 1) {
      return ` (Posted ${differenceInYears} year${
        differenceInYears > 1 ? 's' : ''
      } ago)`;
    }

    if (differenceInMonths >= 1) {
      return ` (Posted ${differenceInMonths} month${
        differenceInMonths > 1 ? 's' : ''
      } ago)`;
    }

    if (differenceInWeeks >= 1) {
      return ` (Posted ${differenceInWeeks} week${
        differenceInWeeks > 1 ? 's' : ''
      } ago)`;
    }

    return differenceInDays === 0
      ? ' (Posted today)'
      : ` (Posted ${differenceInDays} day${
          differenceInDays > 1 ? 's' : ''
        } ago)`;
  };

  const [followedUp, setFollowedUp] = useState(followUp?.status || false);
  const [followUpBottom, setFollowUpBottom] = useState(false);
  const router = useRouter();

  const handleJobFollowup = () => {
    if (!isPro) {
      setShowFollowUpProMembershipPrompt(true);
    } else {
      if (!hasfollowup) {
        setFollowUpBottom(true);
      } else {
        handleTracking('ClickFollowUp', {
          event_category: 'Job',
          Origin: router.pathname,
          Source: 'JobDescription',
          CategoryId: jobDetail.categoryId,
          JobId: jobDetail.id,
          RecruiterId: recruiterDetail?.recruiterId,
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
        });

        (async () => {
          try {
            const followUp = await jobDetailService.doFollowUp({
              jobId: jobDetail.id,
            });
            if (typeof followUp === 'boolean') {
              // await userService.updateFollowUp();
              setFollowedUp(followUp);
            }
          } catch (error: unknown) {
            console.log('🚀 ~ file: index.tsx:298 ~ error:', error);
          }
        })();
      }
    }
  };
  const initiateChat = () => {
    if (!(window as any).chatObject) return;

    (window as any).chatObject.initiateChat({
      type: 'j', // r- recruiter, j- jobseeker
      userId: applicantId,
      recipientId: recruiterDetail.recruiterId,
      tokenName: `${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}_CK1`,
    });
  };
  const jd: JB = useSelector((state: any) => state.jobDetail);

  useEffect(() => {
    if (jd && jd.id === jobDetail.id) {
      console.log('jobDetails', jd);
      setInsightsbox(true);
    }
  }, [jd, jobDetail.id]);

  const openInsightsDialog = async () => {
    if (!isPro) {
      setshowProMembershipPrompt(true);
    } else {
      try {
        await dispatch(fetchJobDetails({jobId: String(jobDetail.id)}));
        await dispatch(
          fetchJobInsights({
            userId: String(applicantId),
            jobId: String(jobDetail.id),
          })
        );

        handleTracking('prostatusview', {
          event_category: 'insightpopup',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
          Origin: router.pathname,
          Type: 'view',
          CompanyId: recruiterDetail.organisationId,
        });
      } catch (error) {
        console.error('Error fetching job insights:', error);
      }
    }
  };
  const shouldShowOpenInAppBanner =
    !isPro &&
    isStatusChangeCohortUser === true &&
    RECRUITER_ACTION_TEXT[app_status] !== 'APPLIED/SENT';
  const isStatusChangeCohortResolved =
    typeof isStatusChangeCohortUser === 'boolean';
  const shouldHoldStatusSlot =
    !isPro &&
    !isStatusChangeCohortResolved &&
    RECRUITER_ACTION_TEXT[app_status] !== 'APPLIED/SENT';
  const canShowActualStatus =
    isPro ||
    isStatusChangeCohortUser === true ||
    RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT';

  useEffect(() => {
    if (
      !shouldShowOpenInAppBanner ||
      isStatusChangeCohortUser !== true ||
      !jobDetail?.id
    ) {
      return;
    }

    TrackEventUBA('appDownloadLinkageView', 'view', {
      pageName: 'Applied Jobs',
      jobID: jobDetail.id,
      sessionUsername: sessionStorage.getItem('userId') || '',
      linkageName: 'Recruiter Action App Install Linkage',
      linkageType: 'Banner',
    });
  }, [shouldShowOpenInAppBanner, isStatusChangeCohortUser, jobDetail?.id]);

  return (
    <>
      <BottomsheetNoTtitle
        maxHeight={170}
        open={followUpBottom}
        onDismiss={() => {
          setFollowUpBottom(false);
        }}
      >
        <Box p={3} pt={0}>
          <Typography variant="body2" fontSize={16} fontWeight={500}>
            You have 0 follow-ups left. You get one follow-up every Thursday.
          </Typography>

          <Button
            sx={{
              width: {lg: '125px'},
              background: '#000',
              mt: {xxs: 1, md: 2},
              px: 2,
              py: 1,
              height: 'fit-content',
              backgroundColor: 'secondary.main',
              borderRadius: 8,
            }}
            variant="contained"
            size="large"
            onClick={() => {
              setFollowUpBottom(false);
            }}
          >
            Okay
          </Button>
        </Box>
      </BottomsheetNoTtitle>
      <Card
        sx={{
          margin: 0,
          boxShadow: 0,
          paddingTop: 0,
          paddingBottom: 0,
          ml: shouldShowOpenInAppBanner ? 0 : 1,
          backgroundColor: shouldShowOpenInAppBanner ? '#EEF6F3' : '#FFFFFF',
          border: shouldShowOpenInAppBanner ? '1px solid #C0DCCE' : 'none',
          borderRadius: shouldShowOpenInAppBanner ? '12px' : 0,
          overflow: 'hidden',
        }}
      >
        {shouldShowOpenInAppBanner ? (
          <Box
            mt={0}
            mb={1.25}
            px={1.25}
            py={1.5}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            maxHeight={56}
            sx={{
              background: '#49966E',
              color: '#fff',
            }}
            onClick={() => {
              TrackEventUBA('appDownloadLinkageClick', 'click', {
                pageName: 'Applied Jobs',
                jobID: jobDetail.id,
                sessionUsername: sessionStorage.getItem('userId') || '',
                linkageName: 'Recruiter Action App Install Linkage',
                linkageType: 'Banner',
              });
              openUrl(
                'https://iimjobs.onelink.me/TyLF/xexkuwnb?deep_link_value=applied_jobs',
                '_blank'
              );
            }}
          >
            <Box display="flex" alignItems="center" gap={0.8}>
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: -1,
                }}
              >
                <Image src={LockPrem} width={10} height={10} alt="lock" />
              </Box>
              <Box mt={-0.375}>
                <Typography fontSize={14} fontWeight={600} lineHeight={'20px'}>
                  Status Changed
                </Typography>
                <Typography
                  fontSize={11}
                  fontWeight={500}
                  lineHeight={'20px'}
                  mt={-0.375}
                >
                  Track recruiter activity on the app
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                backgroundColor: '#FFF',
                borderRadius: '5px',
                // px: 1.25,
                // py: 0.45,
                padding: '2px 5px 2px 6px',
                minWidth: 78,
                minHeight: 24,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                textAlign="center"
                fontSize={12}
                fontWeight={600}
                color="#49966E"
              >
                Install App
              </Typography>
            </Box>
          </Box>
        ) : canShowActualStatus ? (
          <Card
            sx={{
              mt: 2,
              height: 22,
              display: 'inline-flex',
              width: 'auto',
              borderColor:
                RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT' ||
                RECRUITER_ACTION_TEXT[app_status] === 'NOT SUITABLE'
                  ? '#7E7E7E'
                  : '#49966E',
              borderWidth: '0.6px',
              borderStyle: 'solid',
              borderRadius: '6px',
              fontSize: 10,
              color:
                RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT' ||
                RECRUITER_ACTION_TEXT[app_status] === 'NOT SUITABLE'
                  ? '#7E7E7E'
                  : '#49966E',
              backgroundColor:
                RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT' ||
                RECRUITER_ACTION_TEXT[app_status] === 'NOT SUITABLE'
                  ? 'rgba(51, 51, 51, 0.16)'
                  : 'rgba(145, 184, 121, 0.16)',
              padding: '4px 12px',
              fontWeight: 500,
              justifyContent: 'center',
              alignItems: 'center',
              boxSizing: 'border-box',
            }}
          >
            {RECRUITER_ACTION_TEXT[app_status]}
          </Card>
        ) : shouldHoldStatusSlot ? (
          <Box mt={2} minHeight={22} />
        ) : (
          <LockedStatus
            setShowStatusProMembershipPrompt={setShowStatusProMembershipPrompt}
          />
        )}

        <Typography
          variant="body2"
          component="a"
          href={jobUrl}
          sx={{
            cursor: 'pointer',
            userSelect: 'none',
            color: '#333',
            textDecoration: 'none',

            width: 'calc(100% - 8px)',
            paddingTop: 0,
            paddingBottom: 0,
            marginBottom: 0,

            mt: 1,
            fontSize: 12,
            fontWeight: 500,
            fontStyle: 'normal',
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'none',
            },
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            WebkitLineClamp: 2,
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            pl: shouldShowOpenInAppBanner ? 1 : 0,
          }}
          onClick={event => {
            event.preventDefault(); // Prevent default anchor behavior
            openUrl(jobUrl, '_blank', 'noopener,noreferrer');
          }}
        >
          {`${jobDetail.title.replace(/\(.*?\)/g, '').trim()}`}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            marginTop: 0.25,
            paddingTop: 0,
            fontSize: 10,

            fontWeight: 400,
            fontStyle: 'normal',
            color: '#7E7E7E',
            pl: shouldShowOpenInAppBanner ? 1 : 0,
          }}
        >
          {`${jobDetail.min}-${jobDetail.max} yrs`}
          {salaryString && (
            <>
              <span style={{margin: '0 4px'}}>&#9679;</span>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  verticalAlign: 'middle',
                  marginRight: '4px',
                  lineHeight: 1,
                }}
              >
                <Image
                  src={RupeeGrey}
                  width={12}
                  height={12}
                  alt="rupee"
                  style={{marginRight: 0, display: 'block'}} // ← display: block fixes phantom spacing
                />
                <span style={{lineHeight: 1}}>{salaryString}</span>
              </span>
            </>
          )}
          &nbsp;&nbsp;<span>&#9679;</span>&nbsp;&nbsp;
          {loc.length < 4 && loc.join('/').length < 20
            ? loc.join('/')
            : 'Multiple Locations'}
          &nbsp;&nbsp;<span>&#9679;</span> &nbsp;&nbsp;Applied on{' '}
          {new Date(applicationDate)
            .toLocaleDateString('en-GB')
            .split('/')
            .join('-')}
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          mt={1}
          pl={shouldShowOpenInAppBanner ? 1 : 0}
        >
          <Button
            onClick={openInsightsDialog}
            variant="text"
            color="primary"
            sx={{
              textTransform: 'none',
              padding: 0,
              fontSize: 12,
              width: 80,
              height: 16,
              border: 'none',
              boxShadow: 'none',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'none',
              },
              '&:focus': {
                backgroundColor: 'transparent',
              },
              '&:active': {
                backgroundColor: 'transparent',
              },
            }}
          >
            View Insights
          </Button>
          <Typography
            variant="body2"
            sx={{
              ml: 0.25,
              marginTop: 0.25,
              paddingTop: 0,
              fontSize: 10,

              fontWeight: 400,
              fontStyle: 'normal',
              color: '#7E7E7E',
            }}
          >
            {formatPostedTime(jobDetail.createdTime)}
          </Typography>
        </Box>

        <CardContent
          sx={{
            padding: 0,
            mt: 1.5,
            background: shouldShowOpenInAppBanner
              ? 'linear-gradient(0deg, #FFF 0%, #FFF 100%), #FFF'
              : 'linear-gradient(0deg, rgba(255, 255, 255, 0.70) 0%, rgba(255, 255, 255, 0.70) 100%), #E1E4E9',
            width: 'calc(100% - 8px)',
            height: 52,
            ml: shouldShowOpenInAppBanner ? 0.5 : 0,
            borderRadius: 4,
          }}
        >
          <Grid container direction="row">
            <Grid
              item
              xxs={3}
              mt={1}
              ml={2}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 10,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                JOB VIEWS
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  paddingTop: 0.5,
                }}
              >
                {views?.toString()}
              </Typography>
            </Grid>
            <Grid
              item
              xxs={4.17}
              mt={1}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 10,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                APPLICATIONS
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  paddingTop: 0.5,
                }}
              >
                {app_count?.toString()}
              </Typography>
            </Grid>

            <Grid
              item
              mt={1}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: 10,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                RECRUITER ACTIONS
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  paddingTop: 0.5,
                }}
              >
                {recruiterActions?.toString()}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>

        <Typography
          variant="body2"
          sx={{
            marginTop: 1,
            paddingTop: 0,
            fontSize: 8,

            fontWeight: 500,
            fontStyle: 'normal',
            pl: shouldShowOpenInAppBanner ? 1 : 0,
          }}
        >
          Posted by:
        </Typography>

        <Grid
          container
          direction="row"
          mt={0.75}
          mb={inviteStatus ? 0 : shouldShowOpenInAppBanner ? 1.5 : 1}
          pl={shouldShowOpenInAppBanner ? 1 : 0}
        >
          <Grid item mb={0} width={'44px'}>
            <Avatar
              onClick={
                confidential
                  ? () => {}
                  : () => {
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              sx={{
                cursor: confidential ? 'default' : 'pointer',
                height: 40,
                width: 40,
              }}
              imgUrl={confidential ? '' : recruiterDetail.pictureLink}
            />
          </Grid>
          <Grid item ml={0.5} mt={0} mb={0} xxs={5.74}>
            <Typography
              sx={{
                mt: 0,
                pt: 0,
                userSelect: 'none',
                fontSize: 10,
                fontWeight: 500,
                fontStyle: 'normal',
                cursor: confidential ? 'default' : 'pointer',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'none',
                },
              }}
              onClick={
                confidential
                  ? () => {}
                  : event => {
                      event.preventDefault();
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              color="primary"
            >
              {confidential ? 'Verified Recruiter' : recruiterDetail.name}
            </Typography>

            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  paddingBottom: 0,
                  marginBottom: 0,

                  fontSize: 10,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  WebkitLineClamp: 2,
                  textOverflow: 'ellipsis',
                  whiteSpace: 'normal',
                }}
              >
                {`${recruiterDetail.designation} at ${recruiterDetail.organisationName}`}
              </Typography>
            )}
            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  paddingTop: 0,
                  paddingBottom: 0,
                  fontSize: 10,
                  visibility: lastActive ? 'visible' : 'hidden',

                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                Last Active:{' '}
                {lastActive && lastActive?.lastActiveDate
                  ? !isNaN(new Date(lastActive.lastActiveDate).getTime())
                    ? new Date(lastActive.lastActiveDate).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        }
                      )
                    : lastActive.lastActiveDate
                  : ''}
              </Typography>
            )}
          </Grid>

          <Grid
            item
            display={'flex'}
            xxs={4.5}
            justifyContent="flex-end"
            marginTop="0px"
            sx={{paddingRight: '8px'}}
          >
            <Button
              disabled={followedUp || (app_status > 0 && isPro == true)}
              onClick={handleJobFollowup}
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 8,
                width: 110,
                fontSize: 12,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                padding: '8px 27px',
                minWidth: 'auto',
                boxShadow: 3,
                height: 32,
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'none',
                },
                '&:focus': {
                  backgroundColor: 'transparent',
                },
                '&:active': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              {followedUp ? 'Followed Up' : 'Follow Up'}
            </Button>
          </Grid>
        </Grid>
        <Box display="flex" ml={-1} justifyContent="center">
          {inviteStatus &&
          !(
            unpublishInfo &&
            unpublishInfo?.unpublishedDate &&
            unpublishInfo?.unpublishedDate?.length > 1
          ) ? (
            interviewDate &&
            interviewTime &&
            new Date(
              new Date(interviewDate).setHours(
                parseInt(interviewTime.slice(0, 2)),
                parseInt(interviewTime.slice(2))
              ) +
                30 * 60 * 1000
            ) < new Date() ? (
              <></>
            ) : (
              <ScheduledInterview
                slotId={slotId}
                calId={calId}
                remSlots={remSlots}
                date={
                  interviewDate && interviewTime && inviteStatus > 1
                    ? (() => {
                        const dateObj = new Date(interviewDate);
                        dateObj.setHours(
                          parseInt(interviewTime.slice(0, 2)),
                          parseInt(interviewTime.slice(2))
                        );

                        return dateObj
                          .toLocaleString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true, // Use 24-hour format
                          })
                          .replace('at', ',')
                          .replace('am', 'AM')
                          .replace('pm', 'PM');
                      })()
                    : ''
                }
              />
            )
          ) : (
            <></>
          )}
        </Box>
      </Card>
    </>
  );
};

export default AppliedMobTile;
